module.exports = __webpack_public_path__ + "media/assets/img/flags/tr-TR-0436e3acaaa77f5af7157d36c0f68464.png";